import { useContext } from 'react';
import { ModalContext, AppContext, EMPTY_OBJECT } from 'commons-ui';

import useService from '../utils/useService';

export const useHandler = (params: any) => {
	const { rowData = EMPTY_OBJECT, setShowLoader, fetchConfiscationAndRefundData } = params;
	const { showAlert } = useContext(AppContext);
	const { setModalConfig } = useContext(ModalContext);
	const { updateConfiscationAndRefundRequest } = useService();
	const onAgreeConfiscationAndRefund = async () => {
		setModalConfig({ isOpen: false });
		setShowLoader(true);
		try {
			await updateConfiscationAndRefundRequest({ confiscationId: rowData.confiscationId, isApproved: true });
			await fetchConfiscationAndRefundData();
			showAlert('Confiscation request approved sucessfully!', { type: 'success' });
			setShowLoader(false);
		} catch (e: any) {
			showAlert(e.response?.data?.error ?? 'Error while approving the confiscation request', { type: 'error' });
			setShowLoader(false);
		}
	};
	const onDisAgreeConfiscationAndRefund = () => {
		setModalConfig({ isOpen: false });
	};

	return { onAgreeConfiscationAndRefund, onDisAgreeConfiscationAndRefund };
};

export default useHandler;
